import Icon from '../components/Icon.vue'

Icon.register({"wpbeginner":{"width":1792,"height":1792,"paths":[{"d":"M384 832h160v-224h-160v224zM1221 1164v-92q-104 36-243 38-135 1-259.5-46.5t-220.5-122.5l1 96q88 80 212 128.5t272 47.5q129 0 238-49zM640 832h640v-224h-640v224zM1792 800q0 187-99 352 89 102 89 229 0 157-129.5 268t-313.5 111q-122 0-225-52.5t-161-140.5q-19 1-57 1t-57-1q-58 88-161 140.5t-225 52.5q-184 0-313.5-111t-129.5-268q0-127 89-229-99-165-99-352 0-209 120-385.5t326.5-279.5 449.5-103 449.5 103 326.5 279.5 120 385.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wpbeginner.js
// module id = Qdga
// module chunks = 0